import popupFormTmpl from "./formTmpl.vue";
import { CircleClose } from '@element-plus/icons-vue';
import * as Vue from 'vue';
import popupPicture from './popupPicture';
import popupRich from './popupRich';
import popupAgreement from './popupAgreement';
import popupAgreetContent from './popupAgreetContent';
import popupButtom from './popupButtom';
//接口
import * as apis from '@/api/land';
import { $emit } from "@/utils/gogocodeTransfer";
export default {
  components: {
    popupFormTmpl,
    popupPicture,
    popupRich,
    popupAgreement,
    popupAgreetContent,
    popupButtom,
    CircleClose
  },
  props: ['popcontent', 'popsetting', 'tid'],
  data() {
    return {
      bool: false,
      agreetContent: '',
      isxieyi: false,
      iszhezhao: false
    };
  },
  watch: {
    popcontent: {
      handler(value) {
        console.log(value, '123123');
      },
      deep: true
    },
    popsetting: {
      handler(value) {
        console.log(this.popsetting, '234234');
      },
      deep: true
    }
  },
  methods: {
    close() {
      console.log(1111);
      this.bool = false;
      this.iszhezhao = false;
    },
    popxie(row) {
      this.agreetContent = row;
      this.isxieyi = true;
    },
    closeisxieyi() {
      this.isxieyi = false;
    },
    handleEasyOk() {
      if (this.popsetting.isclick) {
        if (this.popsetting.linkType == '0') {
          //跳转
          if (this.popsetting.wholeType == '0') {
            //网页跳转
            window.location.href = this.popsetting.webpageUrl;
          } else if (this.popsetting.wholeType == '2') {
            if (this.popsetting.appletlink == 0) {
              //打开小程序
              $emit(this, 'openWechat', this.popsetting.landsel, this.popsetting.channel);
            } else {
              $emit(this, 'openWechat', 1, this.popsetting.appletUrl);
            }
          } else if (this.popsetting.wholeType == '4') {
            this.close();
            $emit(this, 'jumpKf', this.popsetting.wechatKf);
          } else if (this.popsetting.wholeType == '6') {
            this.close();
            $emit(this, 'jumpCustomerAcquisition', this.popsetting);
          }
        } else if (this.popsetting.linkType == '2') {
          //拨打电话
          window.location.href = 'tel:' + this.popsetting.telephone;
        }
      }
    },
    //跳转微信小程序
    openWechat(landing_page_id, channel_id) {
      if (landing_page_id == '' || channel_id == '' || this.tid == '') return false;
      let parse = {
        tid: this.tid,
        landing_page_id: landing_page_id,
        //落地页id
        channel_id: channel_id //落地页渠道id
      };

      apis.generateScheme(parse).then(res => {
        if (res.code == '200' && typeof res.data.ab_limit != 'undefined' && res.data.ab_limit == 1) {
          this.$emit('blackShow');
          return;
        }
        if (res.code == '200' && res.data.url_scheme) {
          window.location.href = res.data.url_scheme;
        }
      });
    }
  }
};